import Vue from 'vue'
import App from "./App.vue";
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import "isomorphic-fetch"

Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);

Vue.config.productionTip = false;

/*
data: {
        'name' : 'Tobias',
        'workplace' : 'W&Co',
        'email' : 'tobias@strandliv.se',
        'phone' : '0739326511',
        'message' : '',
        'status' : 'idle',
        'files' : []
    }
    */

new Vue({
  render: h => h(App),
    data: {
        'name' : '',
        'workplace' : '',
        'email' : '',
        'phone' : '',
        'message' : '',
        'status' : 'idle',
        'files' : [],
        'intro' : '',
        'documents' : {
            'files' : [],
            'html' : ''
        }
    },
    created: function () {
        fetch('https://team-hf.se/wp-json/wco-api/v1/form').then(r => r.json()).then(r => {
            if(r.result === 'ok'){
                console.log('response', r);
                this.intro = r.content;
                this.documents.files = r.files;
                var html = '<ul>';
                for(var i=0; i<this.$root.documents.files.length; i++){
                    var filePath = this.$root.documents.files[i]['document_file'];
                    var filename = filePath.split("/").pop();
                    html += '<li><a href="' + filePath + '">' + filename + '</a></i>';
                }
                html += '</ul>';
                this.documents.html = html;
            }
        });
    }
}).$mount('#app');
